import { Component, OnInit, forwardRef } from '@angular/core';
import { SmUiComponent } from '../sm-ui/sm-ui.component';
import { ControlContainer, FormGroupDirective, NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';
import { AngularEditorConfig } from "@kolkov/angular-editor";


@Component({
    selector: 'sm-textarea',
    templateUrl: './sm-textarea.component.html',
    styleUrls: ['./sm-textarea.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SmTextareaComponent),
            multi: true
        }
    ]
})
export class SmTextareaComponent extends SmUiComponent implements OnInit{
   
    editorConfig: AngularEditorConfig = {
        editable: true,
        spellcheck: true,
        height: "auto",
        minHeight: "15rem",
        width: "auto",
        minWidth: "0",
        translate: "yes",
        enableToolbar: true,
        showToolbar: true,
        placeholder: "Enter text here...",
        defaultParagraphSeparator: "",
        defaultFontName: "",
        defaultFontSize: "",
        fonts: [
          { class: "arial", name: "Arial" },
          { class: "times-new-roman", name: "Times New Roman" },
          { class: "calibri", name: "Calibri" },
          { class: "comic-sans-ms", name: "Comic Sans MS" },
        ],
        customClasses: [
          {
            name: "quote",
            class: "quote",
          },
          {
            name: "redText",
            class: "redText",
          },
          {
            name: "titleText",
            class: "titleText",
            tag: "h1",
          },
        ],
        uploadUrl: "v1/image",
        uploadWithCredentials: false,
        sanitize: true,
        toolbarPosition: "top",
        toolbarHiddenButtons: [
          [
            "undo",
            "redo",
            "subscript",
            "superscript",
            "justifyLeft",
            "justifyCenter",
            "justifyRight",
            "justifyFull",
            "indent",
            "outdent",
            "heading",
            "fontName",
          ],
          [
            "fontSize",
            "textColor",
            "backgroundColor",
            "customClasses",
            "insertImage",
            "insertVideo",
            "insertHorizontalRule",
            "removeFormat",
            "toggleEditorMode",
          ],
        ],
      };
    
}


